export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-28.7b9d0ba6.jpg";